import type { Scenarios_Bool_Exp, Sizing_Pumping_Type_Enum } from "gql/api";

export function scenariosByOwnerName(name?: string): Scenarios_Bool_Exp {
  if (!name) return {};

  return {
    _or: [{ author: { display_name: { _ilike: `%${name}%` } } }]
  };
}

export function scenariosByTitle(title?: string): Scenarios_Bool_Exp {
  if (!title) return {};

  return {
    _or: [{ title: { _ilike: `%${title}%` } }]
  };
}

export function scenariosByDateRange(dates?: Date[]): Scenarios_Bool_Exp {
  // if undefined or second date not set return empty object
  if (!dates || !dates[1]) return {};

  return {
    _and: [
      { journal_updated_at: { _gte: dates[0] } },
      { journal_updated_at: { _lte: dates[1] } }
    ]
  };
}

export function scenariosByTextSearch(val?: string) {
  if (!val) {
    return {};
  }

  return {
    ...scenariosByTitle(val)
  };
}

export function scenariosSizingsByTextSearch(val?: string) {
  if (!val) {
    return {};
  }

  return {
    _or: [
      { title: { _ilike: `%${val}%` } },
      { sizing: { title: { _ilike: `%${val}%` } } }
    ]
  };
}
export function scenariosByWellName(val?: string) {
  if (!val) {
    return {};
  }

  return {
    sizing: {
      well: {
        well_name: {
          _ilike: `%${val}%`
        }
      }
    }
  };
}
export function scenariosByCustomerName(val?: string) {
  if (!val) {
    return {};
  }

  return {
    sizing: {
      customer: {
        customer_name: {
          _ilike: `%${val}%`
        }
      }
    }
  };
}
export function scenariosByOwnerIdOrHalIdentifier(
  id?: string,
  halIdentifier?: string
) {
  return {
    _or: [
      {
        author: {
          hal_identifier: { _eq: halIdentifier }
        }
      },
      {
        journal_author_id: { _eq: id }
      }
    ]
  };
}

export const scenariosWhereNotDeleted = (): Scenarios_Bool_Exp => ({
  journal_deleted_at: { _is_null: true },
  sizing: { journal_deleted_at: { _is_null: true } }
});

export function scenariosByPumpingType(val?: string): Scenarios_Bool_Exp {
  if (!val) return {};
  return {
    pumping_type: { _eq: val as Sizing_Pumping_Type_Enum }
  };
}
